module.exports = __webpack_public_path__ + "img/mail_ellipse.a9f127f7.jpg";